import {Component, Inject, Input} from 'ng-metadata/core';
import {PersonalizeResultsButtonService} from './personalizeResultsButton.service';
import {SharedSessionStorage} from '../../../infra/sharedSessionStorage.service';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {getAttributesMap} from '../../../appConfig/appConfigForward';
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {IStateParamsService} from 'angular-ui-router';
import {beacon,PrimolyticsService} from "../../../analytics/primolytics.service";

@Component({
    selector: 'prm-personalize-results-button',
    templateUrl: 'components/search/personalization/personalizationButton/personalize-results-button.html',
})

export class PrmPersonalizeResultsButton {   
    @Input() public isTabDisabled = false;
    private personalizationEnabled = getAttributesMap().personalizationEnabled ? getAttributesMap().personalizationEnabled : false;
    
    constructor(private personalizeResultsButtonService: PersonalizeResultsButtonService, 
                private sharedSessionStorage: SharedSessionStorage,
                private jwtUtilService: JwtUtilService,
                @Inject('$stateParams') private $stateParams : IStateParamsService,
                private primolyticsService: PrimolyticsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        this.personalizeResultsButtonService.cancelPressed = true;
        this.personalizeResultsButtonService.editPressed = false;
    }

    
    public doPersonalization() {
        this.enable = !this.enable;
        this.personalizeResultsButtonService.cancelPressed = false;

        this.$timeout(()=>{
            let element= document.querySelector('#personalizationDialog');
            element.focus();
            
        }, 100);

    }

    @beacon({'p':'personalizedResults', 'op':'enable'})
    private sendBeaconEnablePersonalization() {
    }

    @beacon({'p':'personalizedResults', 'op':'disable'})
    private sendBeaconDisablePersonalization() {
    }

    
    get enable() {
        return this.personalizeResultsButtonService.enable && (this.sharedSessionStorage.getItem('personalization') !== null);    
    }
    
    set enable(enable:boolean) {
        this.personalizeResultsButtonService.cancelPressed = false; 
        this.personalizeResultsButtonService.enable = enable;     
        this.sharedSessionStorage.setItem('enable_personalization', enable); 
        //In the first time that we move md-switch to enable (when we don't have personalizations yet, we do not want to invoke a search) 
        if (this.sharedSessionStorage.getItem('personalization') !== null) {
            this.personalizeResultsButtonService.addCameFromPersonalizationParam();
            this.$state.go(STATE_NAMES.SEARCH, this.personalizeResultsButtonService.searchParams, {reload: true});
            if (this.enable)
                this.sendBeaconEnablePersonalization();
            else
                this.sendBeaconDisablePersonalization();
            if (this.isSignedIn()){
                this.personalizeResultsButtonService.setUserPersonalizationPreferencesToDB(this.$stateParams['vid']);
            }
        }
    }

    public isSignedIn(){
        return this.jwtUtilService.isSignedIn();
    }

    public displayDialog() {
        return this.personalizeResultsButtonService.displayDialog();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/personalization/personalizationButton/personalizeResultsButton.directive.ts